import { ITiposDocumento } from './models/ITiposDocumento.model';
import { INombresExamen } from './models/INombresExamen.model';
import { ITiposDictamen } from './models/ITiposDictamen.model';
import { ICurrentUser } from './models/ICurrentUser.model';
import { IEspecialidades } from './models/IEspecialidades.model';
import { IUser } from './models/IUser.model';
import { IExamen } from './models/IExamen.model';
import { IMotivosCierre } from './models/IMotivosCierre.model';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { DatabaseConnection } from './idb.connection';
import { IUsersList } from './models/IUsersList.model';


// CONTROLLERS
import { SessionDataController } from './controllers/sessionData.controller';
import { Router, ActivatedRoute } from '@angular/router';
import { ITiposExamen } from './models/ITiposExamen.model';
import { IExamenesCargados } from './models/IExamenesCargados.model';
//
// Declare Database
//
@Injectable( {
  providedIn: 'root',
} )
export class DatabaseService {
  public idb = new DatabaseConnection();

  public sessionDataController: any;
  public usuarios: any;
  public offlineUsers: any;
  public currentUser: any;
  public motivosCierre: any;
  public tiposDictamen: any;
  public medicosLaborales: any;
  public nombresExamen: any;
  public tiposDocumento: any;
  public tiposExamen: any;
  public examenesPeriodicos: any;
  public examenesReevaluacion: any;
  public examenesPorEnviar: any;
  public examenesPresentismoPorEnviar: any;
  public tiposCaracterizacionSemiologica: any;


  constructor(private router: Router,  private route: ActivatedRoute) {
    this.sessionDataController = new SessionDataController( this.idb );
  }

  public updateOnlineStatusOnOfflineDB( isOnline: boolean ): void {
    this.idb
      .transaction( 'rw', this.idb.sessionData, async () => {
        if ( ( await this.idb.sessionData.where( { id: 1 } ).count() ) === 0 ) {
          const id = await this.idb.sessionData.add( {
            isStillOnline: isOnline,
            baseApiUrl: environment.apiUrl
          } );
          console.log(
            `isStillOnline como no existía se agrego con valor ${ isOnline }`
          );
        } else if (
          ( await this.idb.sessionData.where( { id: 1 } ).count() ) === 1
        ) {
          await this.idb.sessionData
            .update( 1, { isStillOnline: isOnline } )
            .then( ( updated ) => {
              if ( updated ) {
                console.warn( `isStillOnline was updated to ${ isOnline }` );
              } else {
                console.error( 'no se actualizo nada' );
              }
            } );
        }
      } )
      .catch( ( e ) => {
        console.error( `ERROR durante la Transaction isStillOnline` );
        console.log( e.stack || e );
      } );
  }

  public async getOnlineStatusFromOfflineDB(): Promise<any> {
    const data = await this.idb.sessionData.toArray();
    return data[0];
  }

  public updateLastUpdateOnOfflineDB( lastUpdate: number ): void {
    // this.idb.transaction('rw', this.idb.sessionData, async () => {
    //   if ((await this.idb.sessionData.where({ id: 1 }).count()) === 0) {
    //     const id = await this.idb.sessionData.add({ isStillOnline: isOnline });
    //     console.log(`isStillOnline como no existía se agrego con valor ${isOnline}`);
    //   }
    //   else if ((await this.idb.sessionData.where({ id: 1 }).count()) === 1) {
    //     await this.idb.sessionData.update(1, { isStillOnline: isOnline })
    //       .then(function (updated) {
    //         if (updated) {
    //           console.log('se actualizo');
    //           console.log(`isStillOnline was updated to ${isOnline}`);
    //         } else {
    //           console.log('no se actualizo nada');
    //         }
    //       });
    //   }
    // }).catch(e => {
    //   console.log(e.stack || e);
    //   console.log(e.stack || e);
    // });
  }

  public updateMotivosCierreOnOfflineDB(
    motivosCierreData: IMotivosCierre[]
  ): void {
    this.populateTable( 'motivosCierre', motivosCierreData );
  }

  public updateUsuariosOnOfflineDB( usuariosData: IUser[] ): void {
    this.populateTable( 'usuarios', usuariosData );
  }

  public updateOfflineUsersOnOfflineDB( offlineUsersData: IUsersList ): void {
    // this.populateTable('offlineUsers', offlineUsersData);
    this.idb
      .transaction( 'rw', this.idb.offlineUsers, async () => {
        if ( ( await this.idb.offlineUsers.where( { id: 1 } ).count() ) === 0 ) {
          const id = await this.idb.offlineUsers.add( offlineUsersData );
        } else if (
          ( await this.idb.offlineUsers.where( { id: 1 } ).count() ) === 1
        ) {
          await this.idb.offlineUsers
            .update( 1, offlineUsersData )
            .then( ( updated ) => {
              if ( updated ) {
                console.warn(
                  `offlineUsers was updated to ${ offlineUsersData.expirationDate }`
                );
              } else {
                console.error( 'no se actualizo nada' );
              }
            } );
        }
      } )
      .catch( ( e ) => {
        console.error( `ERROR durante la Transaction offlineUsersData` );
        console.log( e.stack || e );
      } );
  }

  public async getOfflineUsersFromOfflineDB(): Promise<any> {
    const data = await this.idb.offlineUsers.toArray();
    return data[0];
  }

  // CURRENT USER FUNCTIONS
  public updateCurrentUserOnOfflineDB( currentUserData: ICurrentUser ): void {
    this.idb
      .transaction( 'rw', this.idb.currentUser, async () => {
        if ( ( await this.idb.currentUser.where( { id: 1 } ).count() ) === 0 ) {
          const id = await this.idb.currentUser.add( currentUserData );
          console.log(
            `CURRENT USER como no existía se agrego con valor ${ currentUserData }`
          );
        } else if (
          ( await this.idb.currentUser.where( { id: 1 } ).count() ) === 1
        ) {
          await this.idb.currentUser
            .update( 1, currentUserData )
            .then( ( updated ) => {
              if ( updated ) {
                console.log( 'se actualizo' );
                console.log( `CURRENT USER was updated to ${ currentUserData }` );
              } else {
                console.log( '`CURRENT USER: no se actualizo nada' );
              }
            } );
        }
      } )
      .catch( ( e ) => {
        console.error( `ERROR durante la Transaction CURRENT USER` );
        console.log( e.stack || e );
      } );
  }

  public async getCurrentUserFromOfflineDB(): Promise<any> {
    const data = await this.idb.currentUser.toArray();
    return data[0];
  }

  //* TIPO DICTAMEN
  public populateTiposDictamenTable( tiposDictamenData: ITiposDictamen[] ): void {
    this.populateTable( 'tiposDictamen', tiposDictamenData );
  }
  public async getAllTiposDictamenFromOfflineDB(): Promise<any> {
    return await this.idb.tiposDictamen.toArray();
  }

  //* MOTIVOS CIERRE
  public populateMotivoCierreTable( motivosCierreData: IMotivosCierre[] ): void {
    this.populateTable( 'motivosCierre', motivosCierreData );
  }
  public async getAllMotivosCierreFromOfflineDB(): Promise<any> {
    return await this.idb.motivosCierre.toArray();
  }

  //* NOMBRE EXAMEN
  public populateNombresEstudiosTable( nombresExamenData: INombresExamen[] ): void {
    this.populateTable( 'nombresExamen', nombresExamenData );
  }
  public async getAllNombresExamenFromOfflineDB(): Promise<any> {
    return await this.idb.nombresExamen.toArray();
  }

  //* TIPO EXAMEN
  public populateTiposExamenTable( tiposExamenData: ITiposExamen[] ): void {
    this.populateTable( 'tiposExamen', tiposExamenData );
  }
  public async getAllTiposExamenFromOfflineDB(): Promise<any> {
    return await this.idb.tiposExamen.toArray();
  }

  public populateTiposCaracterizacionSemiologica( tiposCaracterizacionSemiologica: any[] ): void {
    this.populateTable( 'tiposCaracterizacionSemiologica', tiposCaracterizacionSemiologica );
  }
  public async getAllTiposCaracterizacionSemiologicaFromOfflineDB(): Promise<any> {
    return await this.idb.tiposCaracterizacionSemiologica.toArray();
  }

  //* TIPO DOCUMENTO DE IDENTIDAD
  public populateTiposDocumentoTable( tiposDocumentoData: ITiposDocumento[] ): void {
    this.populateTable( 'tiposDocumento', tiposDocumentoData );
  }
  public async getAlltiposDocumentoFromOfflineDB(): Promise<any> {
    return await this.idb.tiposDocumento.toArray();
  }

  //* ESPECIALIDADES
  public populateEspecialidadesTable( especialidadesData: IEspecialidades[] ): void {
    this.populateTable( 'especialidades', especialidadesData );
  }
  public async getAllEspecialidadesFromOfflineDB(): Promise<any> {
    return await this.idb.especialidades.toArray();
  }


  //* EXAMENS TABLES
  public populatePeriodicosExamenTable( examensData: IExamen[] ): void {
    this.populateTable( 'examenesPeriodicos', examensData );
  }

  public populateFiltradosPeriodicosExamenTable( examensData: IExamen[] ): void {
    this.populateTable( 'examenesPeriodicosFiltrados', examensData );
  }

  public clearTableExamanesPeriodicosFiltrados(): void {
    this.clearTable('examenesPeriodicosFiltrados');
  }

  public async getAllPeriodicosExamenFromOfflineDB(): Promise<any> {
    const examenes = await this.idb.examenesPeriodicos.orderBy('fechaAsignacion').reverse().toArray();
    
    // Aplicar cambios pendientes de presentismo a cada examen
    const examenesConCambiosAplicados = await Promise.all(
      examenes.map(async (examen: any) => {
        return await this.applyPendingPresentismoChanges(examen);
      })
    );
    
    return examenesConCambiosAplicados;
  }
  
  public async getAllPeriodicosExamenFiltradosFromOfflineDB(): Promise<any> {
    const examenes = await this.idb.examenesPeriodicosFiltrados.orderBy('fechaAsignacion').reverse().toArray();
    
    // Aplicar cambios pendientes de presentismo a cada examen
    const examenesConCambiosAplicados = await Promise.all(
      examenes.map(async (examen) => {
        return await this.applyPendingPresentismoChanges(examen);
      })
    );
    
    return examenesConCambiosAplicados;
  }

  public async getCountPeriodicosExamenFiltradosFromOfflineDB() {
    return await this.idb.examenesPeriodicosFiltrados.count();
  }

  public populateReevaluacionExamenTable( examensData: IExamen[] ): void {
    this.populateTable( 'examenesReevaluacion', examensData );
  }

  public populateReevaluacionExamenFiltradosTable( examensData: IExamen[] ): void {
    this.populateTable( 'examenesReevaluacionFiltrados', examensData );
  }

  public clearTableExamanesReevaluacionFiltrados(): void {
    this.clearTable('examenesReevaluacionFiltrados');
  }

  public async getAllReevaluacionExamenFromOfflineDB(): Promise<any> {
    const examenes = await this.idb.examenesReevaluacion.orderBy('fechaAsignacion').reverse().toArray();
    
    // Aplicar cambios pendientes de presentismo a cada examen
    const examenesConCambiosAplicados = await Promise.all(
      examenes.map(async (examen) => {
        return await this.applyPendingPresentismoChanges(examen);
      })
    );
    
    return examenesConCambiosAplicados;
  }

  public async getAllReevaluacionExamenFiltradosFromOfflineDB(): Promise<any> {
    const examenes = await this.idb.examenesReevaluacionFiltrados.orderBy('fechaAsignacion').reverse().toArray();
    
    // Aplicar cambios pendientes de presentismo a cada examen
    const examenesConCambiosAplicados = await Promise.all(
      examenes.map(async (examen) => {
        return await this.applyPendingPresentismoChanges(examen);
      })
    );
    
    return examenesConCambiosAplicados;
  }

  public async getCountReevaluacionExamenFiltradosFromOfflineDB() {
    return await this.idb.examenesReevaluacionFiltrados.count();
  }

  public populateCargadosExamenTable( examensData: IExamenesCargados[] ): void {
    // console.log('populate', examensData);
    this.populateTable( 'examenesCargados', examensData );
  }

  public clearTableExamanesCargados(): void {
    this.clearTable('examenesCargados');
  }

  public async getAllCargadosExamenFromOfflineDB(): Promise<any> {

    const porEnviar = await this.idb.examenesPorEnviar.orderBy('examenData.fechaAsignacion').reverse().toArray();
    const noEnviados = await this.idb.examenesCargados.filter( (item: any) => item.enviado === false).reverse().toArray();
    const enviados = await this.idb.examenesCargados.filter( (item: any) => item.enviado === true).reverse().toArray();

    return [...porEnviar, ...noEnviados, ...enviados];
  }


  public async getSingleExamenItem(tableName:string, itemId:number) {
    let response;
    try {
      response = await this.idb[tableName].get(itemId);
    
      if (response) {
        response = await this.applyPendingPresentismoChanges(response);
      }
    } catch (error) {
      console.error(`ERROR durante GET del examen id: ${itemId} de ${tableName}`, error);
    }

    return response;
  }

  /**
   * Verifica si hay cambios pendientes de presentismo para un examen específico
   * @param examenId ID del examen a verificar
   * @returns Objeto con los datos de presentismo pendientes o null si no hay cambios
   */
  public async getPendingPresentismoChanges(examenId: number): Promise<any> {
    try {
      const pendingChanges = await this.idb.examenesPresentismoPorEnviar.get(examenId);
      return pendingChanges;
    } catch (error) {
      console.error(`ERROR durante GET de cambios pendientes de presentismo para examen id: ${examenId}`, error);
      return null;
    }
  }

  /**
   * Aplica los cambios pendientes de presentismo a un examen
   * @param examen Objeto del examen
   * @returns Examen con los cambios aplicados
   */
  public async applyPendingPresentismoChanges(examen: any): Promise<any> {
    if (!examen || !examen.id) {
      return examen;
    }

    const pendingChanges = await this.getPendingPresentismoChanges(examen.id);
    
    if (pendingChanges) {
      examen.firmaB64 = pendingChanges.examenDataToSend.firmaB64;
      examen.firmaSigString = pendingChanges.examenDataToSend.firmaSigString;
      
      if (pendingChanges.onOnlineSendTo.includes('presente')) {
        examen.asistencia = 'Presente';
        examen.motivoCierre = null;
      } else if (pendingChanges.onOnlineSendTo.includes('ausente')) {
        examen.asistencia = 'Ausente';
      } else if (pendingChanges.onOnlineSendTo.includes('anularAusente')) {
        examen.asistencia = null;
        examen.motivoCierre = null;
      }
    }
    
    return examen;
  }
  /**
   *
   * @param examensData la data original recibida desde el backend para popular los datos en la card
   * @param examensDataToSend el objeto con el formato para ser salvado.
   * @param fueCerrado boolean que explica el motivo
   * @param removeAndSendTo esta siempre debería ir con la primera letra en mayúscula y tiene dos opciones:
   *    1- Reevaluacion
   *    1- Periodicos
   * @example: ejemplo de uso
   * this.databaseService.setExameneOnExamenesPorEnviarTable(originalExamenDataObj, examenDataToSendObj, true, 'Periodicos', 'Periódico');
   */
  public setExameneOnExamenesPorEnviarTable(
    examenData: IExamen,
    examenDataToSend: any,
    fueCerrado: boolean = false,
    removeFrom: string,
    baseApiUrl: string
  ): Promise<any> {
    const removeFromTable = `examenes${ removeFrom }`;

    this.deleteItemFromTable( examenData.id, removeFromTable );
    /**
     * @description revisar la documentación de Dexie.transaction por las dudas
     * @link https://dexie.org/docs/Dexie/Dexie.transaction()
     * @link https://dexie.org/docs/Dexie/Dexie.transaction()#specify-reusage-of-parent-transaction
     */
    return this.idb.transaction( 'rw', this.idb.examenesPorEnviar, async () => {
      const id = await this.idb.examenesPorEnviar.put({
        id: examenData.id,
        onOnlineSendTo: baseApiUrl,
        examenData,
        examenDataToSend,
        fueCerrado,
        labelExamen: this.getLabelByExamenType( removeFrom ),
        errorOnTryToSendBySW: [],
        error: false,
        errorMessage: ''
      } );
    } );
  }

  public setExamenOnPresentismoPorEnviarTable(
    examenDataToSend: any,
    baseApiUrl: string
  ): Promise<any> {
    return this.idb.transaction( 'rw', this.idb.examenesPresentismoPorEnviar, async () => {
      const id = await this.idb.examenesPresentismoPorEnviar.put({
        id: +examenDataToSend.examenNumero,
        onOnlineSendTo: baseApiUrl,
        examenDataToSend,
      } );
      
      return id;
    } );
  }

  public updateExameneOnExamenesPorEnviarTable( removeFrom: string, item: any ): Promise<any> {
    const removeFromTable = `examenes${ removeFrom }`;
    return this.idb.transaction( 'rw', this.idb.examenesPorEnviar, async () => {
      const id = await this.idb.examenesPorEnviar.put( { ...item } );
    } );
  }


  public async getAllExamenesPorEnviarFromOfflineDB(): Promise<any> {
    const data = await this.idb.examenesPorEnviar.orderBy('examenData.fechaAsignacion').reverse().toArray();
    return data;
  }

  public cleanTable(tableName) {
    this.idb[ tableName ].clear();
  }

  public deleteItemFromTable( itemId: number, tableName: string ): void {
    this.idb
      .transaction( 'rw', this.idb[ tableName ], async () => {
        // insertar una collection
        await this.idb[ tableName ].delete( itemId ).catch( ( err ) => {
          console.error(
            `ERROR durante DELETE del examen id: ${ itemId } de ${ tableName }`,
            err
          );
        } );

        /**
         * TODO: investigar mejor este link
         * ? https://dexie.org/docs/Table/Table.delete()
         * ? https://dexie.org/docs/Collection/Collection.delete()
         */
      } )
      .catch( ( e ) => {
        console.error( `ERROR durante la Transaction ${ tableName }` );
        console.log( e.stack || e );
      } );
  }

  private getLabelByExamenType( examenType: string ): string {
    if ( examenType === 'Periodicos' ) {
      return 'Periódico';
    } else if ( examenType === 'Reevaluacion' ) {
      return 'Reconfirmación';
    } else {
      return '';
    }
  }

  /*********************
   * * HELPERS
   *********************/
  /**
   * @method populateTable
   * @param {string} tableName
   * @param {array} data
   * @param {number} [updateDate] this parameter is optional
   */
  private populateTable(
    tableName: string,
    data: Array<any>,
    updateDate?: number
  ): void {
    this.idb[ tableName ].clear();

    this.idb
      .transaction( 'rw', this.idb[ tableName ], async () => {
        // insertar una collection
        await this.idb[ tableName ].bulkPut( data ).catch( ( err ) => {
          console.error( `ERROR durante BulkPut ${ tableName }: `, err );
        } );

        /**
         * TODO: investigar mejor este link
         * ? https://dexie.org/docs/Dexie/Dexie.transaction()#specify-reusage-of-parent-transaction
         */
      } )
      .catch( ( e ) => {
        console.error( `ERROR durante la Transaction ${ tableName }` );
        console.log( e.stack || e );
      } );
  }

  private clearTable(tableName: string) : void {
    this.idb[ tableName ].clear();
  }


  public editTableItem( itemId: number, tableName: string, body: {} ): void{
    this.idb
      .transaction( 'rw', this.idb[ tableName ], async () => {
        // updatear una collection
        await this.idb[ tableName ].update( itemId, body ).catch( ( err ) => {
          console.error(
            `ERROR durante UPDATE del examen id: ${ itemId } de ${ tableName }`,
            err
          );
        } );
      } )
      .catch( ( e ) => {
        console.error( `ERROR durante la Transaction ${ tableName }` );
        console.log( e.stack || e );
      } );
  }
}
